export default __webpack_public_path__ + "static/media/arrow-circle.0d5b3d0d.svg";